export default "__VITE_ASSET__D9N$QDCu__"